import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const DashboardWrapper = (): ReactElement => <Outlet />;

export default DashboardWrapper;
